<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
        <TestimonialsForm @submit-requested="submitRequested"></TestimonialsForm>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import TestimonialsForm from '../forms/FormTestimonials.vue'

export default {
    components: { TestimonialsForm },
    methods: {
        ...mapActions('testimonials', ['postTestimonial']),
        submitRequested(input) {
            this.postTestimonial(input);
        },
    }
}
</script>

<style scoped>
    thead > tr > th {
        text-align: unset !important;
    }
</style>
